module.exports = __webpack_public_path__ + "static/img/topfoottwo_img_log.04afd85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topfoottwo_img_log.png
// module id = kQks
// module chunks = 0